<ng-container *transloco="let t; prefix: 'financing.select-loan-section'">
  <div class="mb-10">
    <h3 class="text-black rfs:text-4xl mb-6">
      {{ t("title") }}
    </h3>
    <p class="text-gray-800 mt-6 mb-10">
      {{ t("text") }}
    </p>
  </div>
  <div class="rounded-xl bg-[#EFFEFC] border border-[#0BC1C0] p-8">
    <div class="flex flex-col md:flex-row justify-between gap-14">
      <div>
        <div
          class="bg-[#56F2EA] rounded-full w-[56px] h-[56px] flex justify-center items-center mb-3"
        >
          <img src="./assets/financing/acquisition.svg" />
        </div>
        <h3 class="rfs:text-2xl text-black mb-4">
          {{ t("card.title01") }}
        </h3>
        <p class="text-gray-700">
          {{ t("card.text01") }}
        </p>
      </div>
      <div>
        <div
          class="bg-[#56F2EA] rounded-full w-[56px] h-[56px] flex justify-center items-center mb-3"
        >
          <img src="./assets/financing/repair.svg" />
        </div>
        <h3 class="rfs:text-2xl text-black mb-4">
          {{ t("card.title02") }}
        </h3>
        <p class="text-gray-700">
          {{ t("card.text02") }}
        </p>
      </div>
    </div>
  </div>
</ng-container>
